import Vue from 'vue'
import Router from 'vue-router'
// const moblie = () => import('@/views/moblie')
const introduction = () => import('@/views/introduction')
const activity = () => import('@/views/activity')
const tutorials = () => import('@/views/tutorials')
const details = () => import('@/views/details')
const form = () => import('@/views/form')
const protocol = () => import('@/views/protocol')

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
export default new Router({
  mode: 'history',
  // base: '/tools/accfreeze/',
  routes: [{
      path: '/',
      redirect: '/tutorials'
    },
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: introduction
    // },
    {
      path: '/activity',
      name: 'activity',
      component: activity
    },
    {
      path: '/tutorials',
      name: 'tutorials',
      component: tutorials
    },
    {
      path: '/details',
      name: 'details',
      component: details
    },
    {
      path: '/form',
      name: 'form',
      component: form
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: protocol
    }
  ]
})
